<template>
    <div class="acc-height mb-2">
        <h3 class="mb-4 pl-4">
            ПОЛИТИКА ЗА ЗАЩИТА НА ЛИЧНИТЕ ДАННИ<br>
            в АдминСофт и АдминСофт Плюс
        </h3>
        <p class="mb-0">
            В своята дейност АдминСофт и нейната специализирана компания за разработка на облачни услуги и иновативни
            решения АдминСофт Плюс прилагат гаранциите за правото на защита на личните данни.
        </p>
        <p>
            В съответствие с членове 13 и 14 от Регламент (ЕС) 2016/679 (Общ регламент относно защитата на данните)
            АдминСофт Плюс Ви информира как се осъществява обработването на личните Ви данни.
        </p>
        <p class="mb-0"><strong>
            Данни за администратора и за контакт с него и длъжностното лице по защита на данните
        </strong></p>
        <p class="mb-0">
            „АДМИНСОФТ ПЛЮС“ ООД, ЕИК 203885156, е администратор на личните данни за целите на обработването, посочени
            по-долу.
        </p>
        <p class="mb-0">
            Данни за контакт с администратора: гр. София бул. Цариградско шосе № 147, ет. 6, адрес на електронна поща: contact@adminplus.bg
        </p>
        <p>
            Данните за контакт с длъжностното лице по защита на данните са: dpo@adminplus.bg
        </p>
        <p class="mb-0"><strong>
            Обработвани лични данни (цели, субекти на данни и категории лични данни, правни основания, период на
            съхранение)
        </strong></p>
        <p class="mb-0">
            Информацията, която може да съдържа Ваши лични данни, се обработва за следните дейности:
        </p>
        <ul class="mb-0">
            <li>
                Сключване и изпълнение на договори
            </li>
            <li>
                Обучение, осъществявано от АдминСофт Плюс
            </li>
            <li>
                Управление на човешките ресурси
            </li>
        </ul>
        <p>
            Във всички случаи на обработване на лични данни обработването им се свежда до целите, за които данните се
            събират, както и за целите на архивирането в обществен интерес, научни, исторически изследвания и
            статистически цели. Личните данни не се използват за несъвместими цели.
        </p>
        <p class="mb-0">
            <strong>
                Сключване и изпълнение на договори
            </strong>
        </p>
        <p class="mb-0">
            В изпълнение на своите дейности, специализирани в разработване и внедряване на софтуер в областта на
            образованието и обучението, АдминСофт Плюс събира и съхранява данни за физически лица по силата на
            сключените договори. Обработваните лични данни са в минимален обем, необходим за идентифицирането на
            страните и за изпълнение на договорите съобразно техния предмет. Достъп до данните се предоставя на трети
            страни само в нормативно установени случаи.
        </p>
        <p class="mb-0">
            Правното основание за обработване на личните данни е чл. 6, пар. 1, б. „б“ от Регламент (ЕС) 2016/679
            (изпълнение на договор или предприемане на стъпки по искане на субекта на данни преди сключването на
            договор).
        </p>
        <p>
            Периодът на съхранение на личните данни е в зависимост от срока на конкретния договор и погасяването на
            давност на претенциите по него.
        </p>
        <p class="mb-0">
            <strong><i>Обучение</i></strong>
        </p>
        <p class="mb-0">
            АдминСофт Плюс провежда обучение по одобрени програми за квалификация на
            педагогически специалисти, чрез он-лайн обучение и провеждане на уебинари. За целите на обученията,
            АдминСофт Плюс събира и съхранява данни за физическите лица, които кандидатстват, участват или са участвали
            в тях.
        </p>
        <p class="mb-0">
            Личните данни се обработват в обем и се съхраняват в периоди, определени от законодателството, регулиращо
            професионалното обучение и професионалната квалификация. Достъп до данните се предоставя на трети страни
            само в нормативно установени случаи.
        </p>
        <p>
            Правното основание за обработване на личните данни е чл. 6, пар. 1, б. „а“ от Регламент (ЕС) 2016/679
            (съгласие на субекта на данни при кандидатстване) и чл. 6, пар. 1, б. „в“ от Регламент (ЕС) 2016/679
            (спазване на законово задължение при издаване на удостоверения и при съхранение на данните).
        </p>
        <p class="mb-0">
            <strong><i>Управление на човешките ресурси</i></strong>
        </p>
        <p class="mb-0">        
            За тази цел обработваме лични данни на кандидати за
            работа, настоящи и бивши служители на дружеството, изискуеми съгласно трудовото и осигурителното
            законодателство. Данните се използват за идентификация на физическите лица, данни за образование и
            квалификация, данни за здравето, свързани с прилагане на изискванията за безопасни и здравословни условия на
            труд, за счетоводното отчитане на дейността. Събраните данни се предоставят на трети страни само в случаите,
            когато това е предвидено в закон. В такива случаи данни могат да бъдат предоставени на оправомощени държавни
            органи за осъществяване на техните правомощия и компетентност.
        </p>
        <p class="mb-0">
            Правното основание за обработване е чл. 6, пар. 1, б. „в“ и чл. 9, пар. 2, б. „б“ от Регламент (ЕС) 2016/679
            (спазване на законово задължение, включително по силата на трудовото право и правото в областта на
            социалната сигурност).
        </p>
        <p>
            Срокът за съхранение е нормативно определен, например 50 години за ведомостите за заплати, до 6 месеца от
            приключване на процедурата по набиране и подбор на персонал за документите, предоставени от кандидатите.
        </p>
        <p class="mb-0">
            <strong>
                Категории получатели на лични данни извън администратора
            </strong>
        </p>
        <p>
            АдминСофт Плюс разкрива лични данни на трети страни и получатели само ако те имат правно основание да ги
            получат. Категориите получатели на личните данни могат да бъдат например „АдминСофт“ ЕООД като част от група
            предприятия с АдминСофт Плюс, държавни органи в съответствие с техните правомощия, доставчици на пощенски и
            куриерски услуги при адресиране на кореспонденция до физически лица. Администраторът не разкрива лични данни
            за целите на директния маркетинг.
        </p>
        <p class="mb-0">
            <strong>
                Предаване на лични данни в трети държави или международни организации
            </strong>
        </p>
        <p>
            АдминСофт Плюс не предава личните данни в трети държави (извън Европейския съюз) или международни
            организации. Ако се наложи такова предаване, то ще се осъществи при наличие на правно основание и подходящи
            гаранции за необходимото ниво на защита на физическите лица, съгласно изискванията на чл. 44 и следващи от
            Регламент (ЕС) 2016/679 (Общ регламент относно защитата на данните).
        </p>
        <p class="mb-0">
            <strong>
                Права на физическите лица
            </strong>
        </p>
        <p class="mb-0">
            АдминСофт Плюс гарантира Вашите права съгласно Регламент (ЕС) 2016/679 (Общ регламент относно защитата на
            данните):
        </p>
        <ul class="mb-0">
            <li>
                право на достъп до личните данни, свързани с физическото лице, които се обработват от администратора;
            </li>
            <li>
                право на коригиране на неточни или непълни лични данни;
            </li>
            <li>
                право на изтриване („право да бъдеш забравен“) на лични данни, които се обработват незаконосъобразно или
                с отпаднало правно основание (изтекъл срок на съхранение, оттеглено съгласие, изпълнена първоначална
                цел, за която са били събрани и други);
            </li>
            <li>
                право на ограничаване на обработването при наличие на спор между администратора и физическото лице до
                неговото решаване и/или за установяването, упражняването или защитата на правни претенции;
            </li>
            <li>
                право на преносимост на данните, когато личните данни се обработват по автоматизиран начин на основание
                съгласие или договор. За целта данните се предават в структуриран, широко използван и пригоден за
                машинно четене формат;
            </li>
            <li>
                право на възражение по всяко време и на основания, свързани с конкретната ситуация на лицето, при
                условие че не съществуват убедителни законови основания за обработването, които имат предимство пред
                интересите, правата и свободите на субекта на данни, или съдебен процес;
            </li>
            <li>
                право на физическото лице да не бъде обект на изцяло автоматизирано решение, включително профилиране,
                което поражда правни последствия за него или го засяга в значителна степен.
            </li>
        </ul>
        <p>
            Произтичащите от Регламент (ЕС) 2016/679 (Общ регламент относно защитата на данните) права може да
            упражните с писмено или електронно заявление до администратора на лични данни. В заявлението следва да
            посочите име, адрес и други данни за идентифицирането Ви като субект на данните, да опишете в какво се
            изразява Вашето искане, предпочитаната от Вас форма за комуникация и действия по Вашето искане.
            Необходимо е да подпишете Вашето искане, да отразите датата на подаване и адреса за кореспонденция с
            Вас.
        </p>
        <p class="mb-0">
            <strong>
                Право на жалба до Комисията за защита на личните данни или до съда
            </strong>
        </p>
        <p>
            Ако считате, че Вашите права по Регламент (ЕС) 2016/679 (Общ регламент относно защитата на данните) са
            нарушени, имате право да подадете жалба до Комисията за защита на личните данни или до съда, по Ваш
            избор.
        </p>
        <p class="mb-0">
            <strong>
                Липса на автоматизирано вземане на индивидуални решения, включително профилиране
            </strong>
        </p>
        <p>
            Администраторът не прилага автоматизирано вземане на индивидуални решения, включително профилиране.
        </p>
        <p class="mb-0">
            <strong>
                Значение на предоставените личните данни
            </strong>
        </p>
        <p>
            Обработваме Вашите лични данни за конкретно указаните по-горе легитимни цели и в голяма част от случаите, в
            които ги събираме и съхраняваме, спазваме законови задължения. Предвид това непредоставянето на лични данни
            препятства възможността Ви да ползвате специализираните услуги и дейности на дружеството.
        </p>
        <p class="mb-0">
            <strong>
                От какви източници получаваме лични данни
            </strong>
        </p>
        <p>
            Обработваните от администратора лични данни се предоставят от физически лица, за които се отнасят, от други
            лица в предвидените в нормативен акт или в договор случаи.
        </p>
        <p class="mb-0">
            <strong>
                Лог файлове
            </strong>
        </p>
        <p>
            Сайтът на АдминСофт Плюс събира данни в лог файлове, съдържащи информация за IP, използван браузър,
            операционна система, дата на посещението. Тази информация не се използва за идентифициране на посетителите,
            а единствено в случаите, когато това е необходимо за съдействие на правоохранителни органи или доказване на
            правни претенции. Относно използваните „бисквитки“ може да получите повече информация в политиката ни за
            бисквитките.
        </p>
        <p class="mb-0">
            <strong>
                Промени в политиката за защита на личните данни
            </strong>
        </p>
        <p>
            Запазваме правото да променяме политиката си за защита на личните данни при промени в нормативната уредба
            или в обстоятелствата, свързани с обработваните лични данни. Ако имате въпроси относно обработването на Ваши
            лични данни, не се колебайте да се свържете с нас на адрес dpo@adminplus.bg
        </p>
    </div>
</template>

<script>
    export default {
        name: "gdpr-personal-data-text"
    }
</script>

<style scoped>

</style>
